const values = [
  {
    title: "الاستدامة",
    description:
      "نضع الاستدامة في صميم عملياتنا ونسعى إلى تقليل الهدر وتعظيم الاستفادة من الموارد.",
  },
  {
    title: "الجودة",
    description:
      "نحرص على تنفيذ عملياتنا وفق أسلوب منظم يضمن جودة الخدمة والنتائج.",
  },
  {
    title: "المسؤولية",
    description:
      "نتعامل مع المواد والبيئة والمجتمع بمسؤولية واهتمام.",
  },
  {
    title: "الاحترافية",
    description:
      "نسعى إلى تقديم تجربة واضحة وموثوقة للعميل في كل مرحلة من مراحل الخدمة.",
  },
];

export default function ValuesSection() {
  return (
    <section className="bg-white py-20 md:py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto mb-14 max-w-2xl text-center">
          <span className="mb-3 inline-block text-sm font-semibold text-green-600">
            قيمنا
          </span>

          <h2 className="text-3xl font-bold text-gray-900 md:text-4xl">
            المبادئ التي نعمل بها
          </h2>

          <p className="mt-5 leading-8 text-gray-600">
            نؤمن أن نجاحنا لا يعتمد على الخدمة فقط، بل على الطريقة التي
            نقدم بها هذه الخدمة.
          </p>
        </div>

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {values.map((value, index) => (
            <div
              key={value.title}
              className="group rounded-2xl border border-gray-200 bg-white p-7 transition duration-300 hover:-translate-y-1 hover:border-green-200 hover:shadow-lg"
            >
              <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-gray-100 text-sm font-bold text-gray-500 transition group-hover:bg-green-600 group-hover:text-white">
                0{index + 1}
              </div>

              <h3 className="mt-6 text-xl font-bold text-gray-900">
                {value.title}
              </h3>

              <p className="mt-3 text-sm leading-7 text-gray-600">
                {value.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}